import React, { PropsWithChildren } from "react";
import cn from "classnames";

import "./ContainerBlock.scss";

const ContainerBlock = ({
    children,
    className,
}: PropsWithChildren<{ className?: string }>) => {
    return (
        <div className={cn("playlist__container-block", className)}>
            {children}
        </div>
    );
};
export default ContainerBlock;
